// 导入axios
import axios from 'axios'
// 使用element-ui Message做消息提醒
import { Message } from 'element-ui'
import Tools from './tools'

const whiteListRoutes = ['/whiteList'] // 白名单路由

// 1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: process.env.API_ROOT,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 200 * 1000
})

// 请求拦截器
service.interceptors.request.use(config => {
  // 获取 Authorization
  const authToken = localStorage.getItem('Authorization')
  if (authToken) {
    config.headers.Authorization = `${authToken}`
  }
  // 获取当前页面的 URL 参数
  const currentParams = Tools.getUrlParams(window.location.href)
  const userToken = currentParams['u']
  // 当前路由携带用户标识u且服务请求参数没有u
  if (userToken) {
    if (config.method === 'get') {
      // 简化对象创建的逻辑
      config.params = config.params || {}
      config.params = Object.assign({}, currentParams, config.params, {
        u: config.params.u || userToken
      })
    } else if (config.method === 'post') {
      // 优化对 POST 数据的处理
      let data = config.data || {}
      if (typeof data === 'string') {
        // 处理 JSON 字符串的情况
        data = JSON.parse(data)
        data = Object.assign({}, currentParams, data, { u: data.u || userToken })
        config.data = JSON.stringify(data)
      } else {
        // 处理对象的情况
        config.data = Object.assign({}, currentParams, config.data, {
          u: config.data.u || userToken
        })
      }
    }
  }
  return config
}, error => {
  console.log('error >>>>>>>:', error)
  // 修正错误处理方式
  return Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  // 接收到响应数据并成功后的一些共有的处理，关闭loading等

  return response
}, error => {
  // 接收到异常响应的处理开始
  if (error && error.response) {
    // 1.公共错误处理
    // 2.根据响应码具体处理
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break
      case 401:
        localStorage.removeItem('Authorization')
        sessionStorage.userName = ''
        localStorage.userName = ''
        window.onbeforeunload = function (e) {
          var forage = window.localForage
          // var local = window.localStorage
          var session = window.sessionStorage
          // local.clear()
          session.clear()
          forage.clear()
        }
        const path = window.$Vue.$route.path
        if (path !== '/login' && !whiteListRoutes.some(route => path.startsWith(route))) {
          window.$Vue.$router.push('/login')
        }
        error.message = '未授权，请重新登录'
        break
      case 403:
        error.message = '拒绝访问'
        break
      case 404:
        error.message = '请求错误,未找到该资源'
        // window.location.href = "/NotFound"
        break
      case 405:
        error.message = '请求方法未允许'
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = error.response.data.message
        break
      case 501:
        error.message = '网络未实现'
        break
      case 502:
        error.message = '网络错误'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '网络超时'
        break
      case 505:
        error.message = 'http版本不支持该请求'
        break
      default:
        error.message = `连接错误${error.response.status}`
        break
    }
  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      Message.error(' 网络请求无响应，请刷新重试，如仍有问题请联系观照团队')
    } else {
      error.message('网络连接失败')
    }
  }
  if (error && error.response && error.response.status !== 401) {
    Message.error(error.message)
  }
  // 处理结束
  // 如果不需要错误处理，以上的处理过程都可省略
  return Promise.resolve(error.response)
})
// 4.导入文件
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js